var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "limited-time-offer-editor" },
    [
      _c("label", [
        _vm._v(
          _vm._s(_vm.$t("whatsapp_business_api.limitedTimeOfferLabel")) + " "
        ),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "description",
          staticStyle: { "margin-bottom": "12px" },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("whatsapp_business_api.ltoDescription")) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("a-input", {
        staticStyle: { "margin-bottom": "12px" },
        attrs: {
          value: _vm.data.text,
          placeholder: _vm.$t("whatsapp_business_api.ltoPlaceholder"),
          maxLength: 60,
        },
        on: { input: _vm.updateText },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "char-count" }, [
        _vm._v(_vm._s((_vm.data.text || "").length) + "/60"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "lto-expiration-toggle" },
        [
          _c(
            "a-checkbox",
            {
              attrs: { checked: _vm.data.hasExpiration },
              on: { change: _vm.updateHasExpiration },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("whatsapp_business_api.showExpirationTimer")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "hint-text" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("whatsapp_business_api.ltoExpirationHint")) +
                "\n        "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }